// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pd-6";
export var imgContainer = "_pd-3";
export var menuIcon = "_pd-5";
export var pillWrapper = "_pd-2";
export var pillsContainer = "_pd-1";
export var subscriptionCard = "_pd-0";
export var subscriptionLogo = "_pd-4";